//actions types
import {GAevent} from "./globan-app-elements/ga_function";
import * as TagManager from "react-gtm-module";

export const SAVE_DATA_FROM_MAIN_PAGE_FORM = 'SAVE_DATA_FROM_MAIN_PAGE_FORM';
export const SAVE_INSURANCE_PLANS_FROM_API = 'SAVE_INSURANCE_PLANS_FROM_API';
export const SAVE_INSURANCE_PLAN_EXTENDED_DATA_FROM_API = 'SAVE_INSURANCE_PLAN_EXTENDED_DATA_FROM_API';

export const SAVE_INSURANCE_PLAN_DATA_FOR_GET_PLAN = 'SAVE_INSURANCE_PLAN_DATA_FOR_GET_PLAN';
export const SAVE_INSURANCE_PLAN_DATA_FOR_VIEW_PLAN = 'SAVE_INSURANCE_PLAN_DATA_FOR_VIEW_PLAN';
export const CLEAR_INSURANCE_PLAN_DATA_FOR_VIEW_PLAN = 'CLEAR_INSURANCE_PLAN_DATA_FOR_VIEW_PLAN';
export const CLEAR_INSURANCE_PLANS_ARRAY_BEFORE_FETCHING = 'CLEAR_INSURANCE_PLANS_ARRAY_BEFORE_FETCHING';
export const CHANGE_PAYMENT_FREQUENCY_VALUE = 'CHANGE_PAYMENT_FREQUENCY_VALUE';
export const CHANGE_FILTER_OPTION = 'CHANGE_FILTER_OPTION';

export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_SINGLE_PRODUCT = 'FETCH_SINGLE_PRODUCT';
export const IS_FAIL_FETCH_SINGLE_PRODUCT = 'IS_FAIL_FETCH_SINGLE_PRODUCT';

export const SAVE_USER_ACCOUNT_DATA = 'SAVE_USER_ACCOUNT_DATA';

// actions creators
export function saveDataFromMainPageForm (main_form_data_object) {

    return {
        type: SAVE_DATA_FROM_MAIN_PAGE_FORM,
        payload: main_form_data_object
    }

}


export function saveInsurancePlansFromAPI (result_insurance_plans_array) {

    return {
        type: SAVE_INSURANCE_PLANS_FROM_API,
        payload: result_insurance_plans_array
    }

}


export function saveInsurancePlanExtendedDataFromAPI (result_insurance_plan_extended_data) {

    return {
        type: SAVE_INSURANCE_PLAN_EXTENDED_DATA_FROM_API,
        payload: result_insurance_plan_extended_data
    }

}


export function saveInsurancePlanDataForGetPlan (plan_data_object) {

    return {
        type: SAVE_INSURANCE_PLAN_DATA_FOR_GET_PLAN,
        payload: plan_data_object
    }

}


export function saveInsurancePlanDataForViewPlan (plan_data_object) {

    return {
        type: SAVE_INSURANCE_PLAN_DATA_FOR_VIEW_PLAN,
        payload: plan_data_object
    }

}


export function clearInsurancePlanDataForViewPlan () {

    return {
        type: CLEAR_INSURANCE_PLAN_DATA_FOR_VIEW_PLAN
    }

}




export function clearInsurancePlansArrayBeforeFetching () {

    return {
        type: CLEAR_INSURANCE_PLANS_ARRAY_BEFORE_FETCHING
    }

}


export function changePaymentFrequencyValue(new_payment_frequency_value) {

    return {
        type: CHANGE_PAYMENT_FREQUENCY_VALUE,
        payload: new_payment_frequency_value
    }

}


export function changeFilterOption(new_filter_option_object) {

    return {
        type: CHANGE_FILTER_OPTION,
        payload: new_filter_option_object
    }

}







// connection with API, and getting insurance plans list JSON

export function fetchInsurancePlans(main_form_data_object) {

    return dispatch => {


        // let result_insurance_plans_array = [
        //     {
        //         "plan_id": "ALL1",
        //         "insurance_company": "Allianz",
        //         "coverage_types_included": "H+RC",
        //         "selected_radio_option": "null",
        //         //start of all fake data that needs to be generated dynamically (or it could be hardcoded? just that coinsurance isn't available with CFE)
        //         "deductible_options" : {
        //             "type": "LOCKED",
        //             "values": [0]
        //         },
        //         "coinsurance_options": {
        //             "type": "LOCKED",
        //             "values": [100]
        //         },
        //         "destination_zone": "Zone 3",
        //         "is_available": "true",
        //         //end of all fake data that needs to be generated dynamically
        //         "guarantee_level_EA_displayed": "Comfort",
        //         "company_guarantee_level": "COMFORT",
        //     },
        //     {
        //         "plan_id": "M1",
        //         "insurance_company": "MSH",
        //         "coverage_types_included": "H+RC",
        //         "selected_radio_option": "null",
        //         //start of all fake data that needs to be generated dynamically (or it could be hardcoded? just that coinsurance isn't available with CFE)
        //         "deductible_options" : {
        //             "type": "LOCKED",
        //             "values": [0]
        //         },
        //         "coinsurance_options": {
        //             "type": "LOCKED",
        //             "values": [100, 90, 80]
        //         },
        //         "destination_zone": "Zone 3",
        //         "is_available": "true",
        //         //end of all fake data that needs to be generated dynamically
        //         "guarantee_level_EA_displayed": "Basic",
        //         "company_guarantee_level": "QUARTZ",
        //     },
        //     {
        //         "plan_id": "H1",
        //         "insurance_company": "Henner",
        //         "coverage_types_included": "H+RC",
        //         "selected_radio_option": "deductible",
        //         //start of all fake data that needs to be generated dynamically (or it could be hardcoded? just that coinsurance isn't available with CFE)
        //         "deductible_options" : {
        //             "type": "AVAILABLE",
        //             "values": [0, 1000, 5000]
        //         },
        //         "coinsurance_options": {
        //             "type": "LOCKED",
        //             "values": [100]
        //         },
        //         "destination_zone": "Zone 3",
        //         "is_available": "true",
        //         //end of all fake data that needs to be generated dynamically
        //         "guarantee_level_EA_displayed": "Basic",
        //         "company_guarantee_level": "",
        //     },
        //     {
        //         "plan_id": "A7",
        //         "insurance_company": "April",
        //         "coverage_types_included": "H+RC",
        //         "selected_radio_option": "coinsurance",
        //         //start of all fake data that needs to be generated dynamically (or it could be hardcoded? just that coinsurance isn't available with CFE)
        //         "deductible_options" : {
        //             "type": "AVAILABLE",
        //             "values": [0, 1000, 5000]
        //         },
        //         "coinsurance_options": {
        //             "type": "AVAILABLE",
        //             "values": [100]
        //         },
        //         "destination_zone": "Zone 3",
        //         "is_available": "true",
        //         //end of all fake data that needs to be generated dynamically
        //         "guarantee_level_EA_displayed": "Basic",
        //         "company_guarantee_level": "",
        //         "spreadsheet_rows": [
        //             {
        //                 "Age": "<18",
        //                 "Tarif ANNUEL FDS TTC": 1266.5025729658028
        //             },
        //             {
        //                 "Age": 24,
        //                 "Tarif ANNUEL FDS TTC": 1552.842285114593
        //             }
        //         ]
        //     },
        // ];


        // dispatch(saveInsurancePlansFromAPI(result_insurance_plans_array));

        // this request is served by Express hosted in the same heroku container, proxied by React on localhost
        let fetch_result = fetch("https://hammasoskari-proxy.herokuapp.com/https://ea-quoteapp-dev.herokuapp.com/get-price-data/", {
            // let fetch_result = fetch("/get-price-data/", {

            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data:  main_form_data_object

            })
        });

        fetch_result
            .then(response => {


                return response.json();

            })
            .then(json => {

                console.log(json);

                /**
                 * Very not elegant attempt to overcome the deductible bug by setting the deductible value into the plans objects
                 * already on the front-end. It works bulletproof
                 */
                for (let plan of json) {
                    if (main_form_data_object.insuree_has_cfe === "YES") {
                        console.log("Inside insuree_has_cfee===YES now, locking deductible");
                        plan.deductible_options = {
                            "type": "LOCKED",
                            "values": ["100"],
                            "locked_reason": "Le choix du montant de la franchise n’est pas possible pour une assurance complémentaire à la CFE."
                        };
                        //set the selected option to coinsurance automatically, but only for April, other companies won't have coinsurance
                        // and deductible options at the same time. for other companies (so far only MSH - set it to null because no option will be available)
                        if (plan.company === "April")
                            plan.selected_radio_option = "coinsurance";
                        else
                            plan.selected_radio_option = "null";
                    }
                }

                dispatch(saveInsurancePlansFromAPI(json));

            });

    }

}



// connection with API, and getting insurance plan extended data JSON

export function fetchInsurancePlanExtendedData(insurance_company, company_guarantee_level, data_type_for_USA_MSH) {

    return dispatch => {

        // let result_insurance_plan_extended_data = {
        //     plan_id: "A2",
        //     company: "April",
        //     company_guarantee_level: "ESSENTIELLE",
        //     coverage_sum: "1000000",
        //     coverage_levels: [
        //         {
        //             coverage_level_to_match: "H",
        //             level_name: "Hospitalisation",
        //             level_values: {
        //                 "Chambre d'hopital": "€75.00",
        //                 "Hospitalisation de jour": "100%"
        //             }
        //         },
        //         {
        //             coverage_level_to_match: "RC",
        //             level_name: "Soins Courants",
        //             level_values: {
        //                 "Ostheopatie, chiropractie \n Homeopathie, acupuncture, Med Chin": "100%", //зверни увагу на <br/>
        //                 "Bilan de Sante \n Depistages Cancer": "NON", //а в цьому випадку, якщо щось NON треба завжди перевіряти кожне value if (level_values[key] === "NON") то відображаємо щось захардкоджене що означає "недоступно". Можливо доведеться колись міняти між червоним хрестиком, сірим хрестиком, надписом NON, Not available і т.д. і т.п. і обов'язково таке недоступне значення має бути виділено сірим шрифтом і відрізнятись від інших
        //             }
        //         },
        //         {
        //             coverage_level_to_match: "M",
        //             level_name: "Maternite",
        //             level_values: {
        //                 "Plafond Total Maternite": "NON",
        //                 "Si accouchement Chirurgical": "NON",
        //                 "Plafond complication": "NON",
        //                 "Traitement Sterelite": "NON",
        //             }
        //         }
        //     ]
        // };

        // dispatch(saveInsurancePlanExtendedDataFromAPI(result_insurance_plan_extended_data));

        //todo: host all these files on EA back-end and query EA backend
        // this request is served by Express hosted in the same heroku container, proxied by React on localhost
        let fetch_result_url;

        if ( data_type_for_USA_MSH ) {

            fetch_result_url = "https://hammasoskari-proxy.herokuapp.com/http://tech.marffa.com/"+insurance_company+"-"+company_guarantee_level+"-USA-"+data_type_for_USA_MSH+".json";

        } else {

            fetch_result_url = "https://hammasoskari-proxy.herokuapp.com/http://tech.marffa.com/"+insurance_company+"-"+company_guarantee_level+".json";

        }

        let fetch_result = fetch(fetch_result_url, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });


        fetch_result
            .then(response => {

                return response.json();

            })
            .then(json => {
                console.log(json);
                dispatch(saveInsurancePlanExtendedDataFromAPI(json));

            });

    }

}



// connection with API, and sending selected insurance plan data JSON

export function sendSelectedInsurancePlanToEmail(data_for_sending) {

    return dispatch => {

        // this request is served by Express hosted in the same heroku container, proxied by React on localhost
        // let fetch_result = fetch("https://hammasoskari-proxy.herokuapp.com/http://tech.marffa.com/insurance/send-email.php", {
        let fetch_result = fetch("https://expat-assurance.com/wp-json/quoteapi/getplan-submit/", {

            // let insurancePlansArray = fetch("/get-price-data/", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data_for_sending

            })
        });

        fetch_result
            .then(response => {

                return response.json();

            })
            .then(json => {

                if ( json === 'Email has sent successfully.' ) {

                    //    TODO: зробити перевірку

                } else {

                    // alert(json);

                }

            });

    }

}




// connection with API, and sending user CONTACT FORM data

export function sendUserContactFormDataToEmail(data_for_sending) {

    console.log(data_for_sending);

    return dispatch => {

        // this request is served by Express hosted in the same heroku container, proxied by React on localhost
        let fetch_result = fetch("https://hammasoskari-proxy.herokuapp.com/http://tech.marffa.com/insurance/send-contact-form-data.php", {

            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data_for_sending
            })
        });

        fetch_result
            .then(response => {

                return response.json();

            })
            .then(json => {

                if ( json === 'Email has sent successfully.' ) {

                    //    TODO: зробити перевірку

                } else {

                    // alert(json);

                }

            });

    }

}


export function  sendContactInformation (user_info) {
    return dispatch => {
        // console.log("EMAIL SENDED!", user_info );
        // fetch("https://expat-assurance.com/wp-json/quoteapi/new-widget-vardump/", {
        //     method: "POST",
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({
        //         user_info
        //     })
        //
        // })

        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

        fetch(`https://api.telegram.org/bot5180455823:AAGBoxbz7OD52APTYJ75Wq-A_F4YMUYrn4k/sendMessage?chat_id=-1001675808141&parse_mode=html&text=Widget submit ${ date }`, {
            // fetch("https://staging3.expat-assurance.com/wp-json/quoteapi/new-widget-vardump/", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user_info
            })

        })

        fetch(`https://api.telegram.org/bot5180455823:AAGBoxbz7OD52APTYJ75Wq-A_F4YMUYrn4k/sendMessage?chat_id=-1001675808141&parse_mode=html&text=${JSON.stringify({user_info})}`, {
            // fetch("https://staging3.expat-assurance.com/wp-json/quoteapi/new-widget-vardump/", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user_info
            })

        })
        //
        // fetch("https://comparateur.expat-assurance.com/widget-submit/", {
        //     // fetch("https://staging3.expat-assurance.com/wp-json/quoteapi/new-widget-vardump/", {
        //     method: "POST",
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({
        //         user_info
        //     })
        //
        // })
            .then(
                GAevent("New widget submit " + window.location.hostname, window.location.href, "New widget submit"),
                TagManager.dataLayer({
                    dataLayer: {
                        event: 'New widget submit',
                        pagePath: window.location.href,
                        pageTitle: window.location.hostname,
                    },
                }),
                console.log('New widget submit')
            )

    }
}
